import React from 'react';
import { connect } from 'react-redux';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const Sharing = ({ sessions }) => {
  const link = `${sessions[0].urls.register}?shared=true`;
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>{t('in_person_training.event_overview.sharing.title')}</span>
      </SectionHeader>
      <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
        {t('in_person_training.event_overview.sharing.description')}
      </Text>
      <input
        className="NewInput NewInput--lightestGray NewInput--fw mt-15"
        value={link}
        readOnly
      />
    </Section>
  );
};

const mapStateToProps = state => ({
  sessions: state.sessions,
});

export default connect(mapStateToProps)(Sharing);
